/**
 * ProtectedRoute — Garde de route avec vérification d'authentification
 *
 * Redirige vers /login si l'utilisateur n'est pas connecté.
 * Peut restreindre l'accès à certains rôles.
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.js';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** Rôles autorisés — si non spécifié, tout utilisateur authentifié est accepté */
  allowedRoles?: Array<'ADMIN' | 'USER'>;
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { user, isLoading, isAuthenticated } = useAuth();

  // Chargement en cours
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-primary border-t-transparent" />
      </div>
    );
  }

  // Non authentifié
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Rôle insuffisant
  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
